export default {
  title: 'Página no encontrada',
};
